<template>
    <div>
        <Modal
            ref="modal-appointment"
            id="modal-appointment"
            :size="'md'"
            v-if="show"
            @close="hide()"
        >
            <div slot="header" class="d-block">
                <div class="p-3 header-sidebar">
                    <div class="col-12" style="z-index: 999" @click="hide()">
                        <img v-img-prefix class="img-close float-right" :src="`/public-assets/close-modal`"
                             alt="close-modal"/>
                    </div>
                </div>
            </div>
            <div slot="body" class="d-block">
                <div class="container">
                    <div class="row">
                        <div class="col-12 appointment-title">
                            <span class="circle-blue">1</span> Selecciona una sucursal
                        </div>
                        <div class="col-12 store-name">
                            {{ location.title }}
                        </div>
                        <div class="col-12 store-details txt-blue">
                            En una sucursal {{ location.store }}
                        </div>
                        <div class="col-12 store-details">
                            {{ location.address }}
                            <hr/>
                        </div>
                        <div
                            class="col-12 alert alert-warning"
                            v-if="
                getDistanceFromLatLonInKm(
                  positions.coords.latitude,
                  positions.coords.longitude,
                  location.lat,
                  location.lng
                ).toFixed(2) > 3 && calendar
              "
                        >
                            Esta sucursal se encuentra muy lejos de tu ubicación.
                        </div>
                    </div>
                    <div class="row" v-show="!loading && calendar">
                        <div class="col-12 appointment-title">
                            <span class="circle-blue">2</span> Selecciona un día y una hora
                        </div>
                        <div class="col-12">
                            <dayPicker
                                v-if="calendar != null"
                                :calendar="calendar"
                                :setDate="setDate"
                                :date="date"
                            ></dayPicker>
                            <hr/>
                        </div>
                    </div>
                    <div class="row" v-show="!loading && !calendar">
                        <div class="col-12 appointment-title">
                            No hay citas disponibles para esta sucursal
                        </div>
                    </div>
                    <div
                        class="row text-center hours-container"
                        v-if="!loading && date != null"
                    >
                        <div
                            class="col-12 py-2 hour-container"
                            v-for="(hour, index) in hours"
                            :key="`hour${index}`"
                            @click="time = hour"
                            :class="time === hour ? 'active' : ''"
                        >
                            {{ formatTime(hour) }}
                        </div>
                        <div class="col-12">
                            {{ hours.length === 0 ? "No hay horarios disponibles" : "" }}
                            <hr/>
                        </div>
                    </div>
                    <div class="row" v-if="!loading && time != null">
                        <div class="col-12 mt-3 appointment-title">
                            <span class="circle-blue">3</span> Agenda tu cita
                        </div>
                        <div
                            class="sucursal-appointment text-center col-12 mt-3"
                            v-if="!creating"
                        >
                            <button
                                class="btn scheudleButton"
                                @click.prevent="rescheduleAppointment(location)"
                            >
                                FINALIZAR
                            </button>
                        </div>
                        <div class="col-12 text-center" v-else>
                            <div class="spinner-border text-primary mx-auto" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="loading">
                        <div class="spinner-border text-primary mx-auto" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import dayPicker from "../appointments/dayPicker.vue";
import Modal from "../modals/Modal.vue";

export default {
    components: {
        dayPicker,
        Modal,
    },
    props: {appointment: Object, positions: Object},
    data() {
        return {
            show: false,
            location: null,
            contact: null,
            token: null,
            loading: false,
            creating: false,
            config: null,
            calendar: null,
            time: null,
            date: null,
            location_mongo: null,
            hours: [],
            appointments: [],
            accessToken: "",
        };
    },
    created() {
        let url = "/appointment/get-appointment-info";
        this.$axios
            .post(url, this.appointment)
            .then((response) => {
                this.location = response.data.location
                this.contact = response.data.contact
                this.calendar = response.data.calendar
                this.locationMongo = response.data.location_mongo
                this.show = true;
                this.loading = false;
            })
            .finally(() => {
                this.$bus.$emit("modal-loaded");
            });
    },
    methods: {
        formatTime(time) {
            return this.$moment(time, "hh:mm A").format("hh:mm A");
        },
        resetData() {
            this.time = null;
            this.hours = [];
            this.appointments = [];
            this.date = null;
            this.config = null;
            this.calendar = null;
            this.resetLocation();
        },
        formatDate(date) {
            return this.$moment(date).format();
        },
        formatHour(date) {
            return this.$moment(date).format("HH:mm");
        },
        hide() {
            this.$bus.$emit("modal-closed");
            this.show = false;
        },
        setDate(date) {
            this.date = date;
            this.loading = true;
            this.time = null;
            this.hours = [];
            let day = date.clone().format("dddd");
            if (this.calendar.config.working_hours[day.toLowerCase()]) {
                this.config = this.calendar.config.working_hours[day.toLowerCase()];
                let data = {
                    object_model: "Location",
                    object_id: this.location.id,
                    calendar_id: this.calendar ? this.calendar.id : null,
                    start: this.formatDate(date.clone().toDate().setHours("00", "00")),
                    end: this.formatDate(date.clone().toDate().setHours("23", "59")),
                };
                this.$axios
                    .post("/appointment/get-appointments", data)
                    .then((response) => {
                        this.date.set({hour: 12, minute: 0});
                        this.appointments = response.data.data && response.data.data.appointments ? response.data.data.appointments : [];
                        this.config.forEach((dayConfig) => {
                            let start = this.$moment();
                            let start_date = dayConfig.start.split(":");
                            start.set({
                                hour: start_date[0],
                                minute: start_date[1],
                                second: 0,
                                milisecond: 0,
                            });
                            let end = this.$moment();
                            let end_date = dayConfig.end.split(":");
                            end.set({
                                hour: end_date[0],
                                minute: end_date[1],
                                second: 0,
                                milisecond: 0,
                            });
                            let check_start = start.clone().utc().local();
                            let check_end = end.clone().utc().local();
                            while (check_start < check_end && check_start !== check_end) {
                                if (this.spotIsAvailable(this.formatHour(check_start)) && !(check_start.hours() === check_end.hours() && check_start.minutes() === check_end.minutes())) {
                                    this.hours.push(this.formatHour(start));
                                }
                                check_start = check_start.add(this.calendar.config.options.appointment_duration, "m")
                                start = start.add(this.calendar.config.options.appointment_duration, "m")
                            }
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.$swal.fire(
                    "No hay citas disponibles para esta fecha",
                    "",
                    "warning"
                );
                this.config = "default";
                this.date = null;
                this.appointments = [];
            }
        },
        spotIsAvailable(date) {
            return this.checkAppointments(date) && this.checkExceptions(date) && this.checkTime(date)
        },
        checkTime(date) {
            let response = true;
            let time = this.date.clone().toDate();
            let start_time = date.split(":");
            time.setHours(start_time[0], start_time[1]);

            let break_start = new Date();

            if (time.getTime() < break_start.getTime()) {
                response = false;
            }
            return response;
        },
        checkExceptions(date) {
            let response = true;
            let time = this.date.clone().toDate();
            let start_time = date.split(":");
            time.setHours(start_time[0], start_time[1]);
            this.calendar.config.exceptions.forEach((exception) => {
                let break_start = new Date(exception.start);
                let break_end = new Date(exception.end);
                if (time >= break_start && time < break_end) {
                    response = false;
                }
            });
            return response;
        },
        checkAppointments(date) {
            let response = true;
            let time = this.date.clone().toDate();
            let start_time = date.split(":");
            let uses = 0;
            time.setHours(start_time[0], start_time[1], "00", "00");
            this.appointments.forEach((appointment) => {
                let break_start = new Date(appointment.object_activity.start);
                let break_end = new Date(appointment.object_activity.end);
                if (
                    time.getTime() >= break_start.getTime() &&
                    time.getTime() < break_end.getTime()
                ) {
                    uses++;
                    if (this.calendar.config.options.appointments_per_slot <= uses) {
                        response = false;
                    }
                }
            });
            return response;
        },
        checkMyAppointments(date) {
            let response = true;
            let time = this.date.clone().local().toDate();
            let start_time = date.split(":");
            time.setHours(start_time[0], start_time[1], "00", "00");
            this.contact.relationships.assignedAppointments.forEach((appointment) => {
                let break_start = new Date(appointment.object_activity.start);
                let break_end = new Date(appointment.object_activity.end);
                if (
                    time.getTime() >= break_start.getTime() &&
                    time.getTime() < break_end.getTime()
                ) {
                    response = false;
                }
            });
            return response;
        },
        async rescheduleAppointment() {
            this.creating = true;
            let data = {
                data: {
                    object_model: "Location",
                    type: "reschedule",
                    object_id: this.location.id,
                    title: `${this.contact.full_name}`,
                    description: `Cita para ${this.contact.full_name} de la sucursal ${this.location.title}`,
                    location: "Sucursal",
                    calendar_id: this.calendar ? this.calendar.id : null,
                    attendant_type: "Contact",
                    location_id: this.locationMongo.location_id,
                    location_data: this.location,
                    user_location: this.positions,
                    contact: this.contact,
                    url: window.location.origin
                },
            };
            let start = this.$moment(this.date);
            let time = this.time.split(":");
            start = start.set({hour: time[0], minute: time[1], second: 0});

            data.data.start = start.format();
            let end = this.$moment(start).add(
                this.calendar.config.options.appointment_duration,
                "m"
            );
            data.data.end = end.format();
            data.data['form'] = {
                given_name: this.locationMongo.given_name,
                last_name: this.locationMongo.last_name,
                email: this.locationMongo.email,
                phone: this.locationMongo.phone,
                interests: this.locationMongo.interest,
                form_slug: 'citas-sucursales',
            }

            this.$bus.$emit("cancel-appointment", [this.appointment, false]);
            let user = await this.verifyContact();
            data.data["attendee_id"] = user.id;
            data.data.appointment_date = this.cleanDate(this.$moment(data.start).format("YYYY-MMMM-DD"))
            data.data.appointment_schedule_time = this.$moment(this.time, "hh:mm A").format("hh:mm A")

            this.$axios.post('/appointment/create-appointment', data)
                .then(() => {
                    this.$swal.fire(
                        "Cita agendada",
                        "Tu cita se agendó correctamente",
                        "success"
                    );
                    window.location.href = `/contactos/perfil?data=${btoa(JSON.stringify(data))}`;
                })
                .catch(error => {
                    this.$swal.fire(
                        "La cita no se pudo agendar.",
                        error.response.data,
                        "warning"
                    );
                    this.setDate(this.date)
                    this.creating = false
                })
                .finally(() => {
                    this.creating = false
                    dataLayer.push({
                        event: 'reschedule_appointment',
                    })
                })
        },
        async verifyContact() {
            let data = {
                given_name: this.contact.given_name,
                last_name: this.contact.last_name,
                email: this.contact.email,
                now: this.$moment().format(this.dateFormat),
            };
            if (this.contact.phone && this.contact.phone !== "") {
                data.phone = {
                    number: this.contact.phone,
                    country: "MX",
                    countryCode: "+52",
                    fullNumber: this.contact.phone,
                };
            }
            return await this.$axios
                .post("/appointment/contact-session", data)
                .then((res) => {
                    return res.data.data;
                })
                .catch((error) => {
                    console.error(error);
                    this.creating = false;
                });
        },
        getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            let R = 6371; // Radius of the earth in km
            let dLat = this.deg2rad(lat2 - lat1); // this.deg2rad below
            let dLon = this.deg2rad(lon2 - lon1);
            let a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.deg2rad(lat1)) *
                Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c; // Distance in km
        },
        deg2rad(deg) {
            return deg * (Math.PI / 180);
        },
        getLocationData(calendar_id, key) {
            let location = this.locations.find((el) => el.calendar_id === calendar_id);
            return location && location[key] ? location[key] : "";
        },
        cleanDate(date) {
            let explodeDate = date.split("-");
            let month = "";
            switch (explodeDate[1]) {
                case "January":
                    month = "Enero";
                    break;
                case "February":
                    month = "Febrero";
                    break;
                case "March":
                    month = "Marzo";
                    break;
                case "April":
                    month = "Abril";
                    break;
                case "May":
                    month = "Mayo";
                    break;
                case "June":
                    month = "Junio";
                    break;
                case "July":
                    month = "Julio";
                    break;
                case "August":
                    month = "Agosto";
                    break;
                case "September":
                    month = "Septiembre";
                    break;
                case "October":
                    month = "Octubre";
                    break;
                case "November":
                    month = "Noviembre";
                    break;
                case "December":
                    month = "Diciembre";
                    break;
                default:
                    month = explodeDate[1];
                    break;
            }

            return `${explodeDate[2]} de ${month} del ${explodeDate[0]}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "vue-awesome-notifications/dist/styles/style.css";

.hours-container {
    max-height: 190px;
    overflow-y: scroll;
}

.hour-container:hover, .hour-container.active {
    background-color: #f7f7f7;
    color: #f9a13b;
    cursor: pointer;
}

.scheudleButton {
    background-color: #f9a13b !important;
    color: white !important;
}

.scheudleButton:hover {
    background-color: #2d5291 !important;
}

.modal-lg {
    @media (min-width: 320px) and (max-width: 575px) {
        padding: 0 !important;
        margin: 0;
        width: 100%;
        border-radius: 0;
    }
}

#modal-appointment {
    @media (min-width: 320px) and (max-width: 575px) {
        padding: 0;
        margin: 0;
    }
}

.modal-content {
    border: 0 !important;
    outline: 0 !important;
    box-shadow: 0 0 6px rgb(0, 0, 0, 30%);
    font-size: 14px;
    @media (min-width: 320px) and (max-width: 575px) {
        box-shadow: none;
        font-size: 12px;
        border-radius: 0;
    }
}

.appointment-title {
    font-weight: 600;
    color: #2d5291;
    margin-bottom: 10px;

    .circle-blue {
        background: #2d5291;
        border-radius: 100%;
        color: #fff;
        width: 24px;
        height: 24px;
        display: inline-block;
        text-align: center;
        margin: 1px 5px 0 0;
    }
}

.form-container input, .form-container select {
    border: lightgray 1px solid;
    height: 40px;
}

.store-name {
    font-weight: 800;
    margin-bottom: 5px;
}

.store-details {
    font-size: 14px;
    color: #6e6d6d;
}

.txt-bue {
    color: #2d5291;
}

.calendar-container {
    font-size: 14px;
    color: #6e6d6d;

    .col {
        padding: 0 10px;
    }

    .available {
        color: #797979;
    }

    .active {
        color: #f48b0d;
        font-weight: 600;
    }
}

#modal-appointment {
    .active {
        color: #f48b0d;
        font-weight: 600;
    }
}

.hour-container:hover {
    background-color: transparent !important;
}

.btn {
    padding: 4px 25px !important;
    width: 80%;
}

.modal-header {
    border: 0 !important;
    position: absolute;
    right: 0;
    top: -3px;
    z-index: 99999;

    .close {
        color: #2d5291;
        opacity: 1;
    }
}

.hour {
    @media (min-width: 320px) and (max-width: 575px) {
        padding-bottom: 24px;
    }
}

.return-button {
    color: var(--prestaprenda-blue);
}

.return-button:hover {
    cursor: pointer;
    color: var(--prestaprenda-blue);
    text-decoration: underline;
}
</style>
